import { z } from 'zod';
import { BIOME_IDS } from '../data/biomes.js';
import { RARE_MOB_IDS } from '../data/rare-mobs.js';
/**
 * A wandering rare (ADR 0094) came, fell or left, sent to the players of its
 * region with the announcement: the client plays its call and marks it.
 * Where it stands is never told: the region is the only hint.
 */
export const RareMobEventSchema = z
    .object({
    mob: z.enum(RARE_MOB_IDS),
    biome: z.enum(BIOME_IDS),
    phase: z.enum(['appeared', 'slain', 'gone']),
})
    .strict();
//# sourceMappingURL=rare-mobs.js.map